import Action from 'src/redux/action'
import { ContextState, NoContext } from 'src/context/types'

export default (
  context: ContextState = NoContext(),
  action: Action,
): ContextState => {
  switch (action.type) {
    default:
      return context
  }
}
